import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class InfoModalComponent {
  @Input() title: string;
  @Input() message: string;
  @Output() readonly responseChanged = new EventEmitter();

  closeModal(): void {
    this.responseChanged.emit(false);
  }
}
